import { Component, inject } from '@angular/core';
import { AlertService, AlertToast } from '../../services/alert.service';

@Component({
  selector: 'lib-alert-toast-stack',
  templateUrl: './alert-toast-stack.component.html',
  styleUrls: ['./alert-toast-stack.component.scss'],
})
export class AlertToastStackComponent {
  private readonly alerts = inject(AlertService);

  readonly toasts$ = this.alerts.toasts$;

  trackById(_index: number, toast: AlertToast): number {
    return toast.id;
  }

  dismiss(id: number): void {
    this.alerts.dismiss(id);
  }
}
